import * as types from "./mutation-types";

export default {
  [types.SET_LOCALE](state, locale) {
    state.locale = locale;
  },
  [types.LOAD_FROM_CACHE](state, cached) {
    state.security.username = null;
    state.security.firstName = null;
    state.security.lastName = null;
    state.security.avatarUrl = null;
    state.security.birthday = null;
    state.security.phoneNumber = null;
    state.security.gender = null;
    state.security.subscribed = null;
    state.security.user = null;

    if (cached.security) {
      state.security.username = cached.security.username || null;
      state.security.firstName = cached.security.firstName || null;
      state.security.lastName = cached.security.lastName || null;
      state.security.avatarUrl = cached.security.avatarUrl || null;
      state.security.user = cached.security.user || null;
    }
  },
  [types.SET_DEALS](state, deals) {
    state.deals = deals;
  },
  [types.LAYOUT_TOGGLE_SUBHEADER]({ layout }) {
    layout.subheader.visible = false;
  },
  [types.LAYOUT_TOGGLE_PRIMARY_CHAT]({ layout }) {
    layout.chat.primary.visible = !layout.chat.primary.visible;
  },
  [types.LAYOUT_TOGGLE_SECONDARY_CHAT]({ layout }) {
    layout.chat.secondary.visible = !layout.chat.secondary.visible;
  },
  [types.LAYOUT_HIDE_SECONDARY_CHAT]({ layout }) {
    layout.chat.secondary.visible = false;
  },
};
